import React, { useEffect, useState } from 'react';
import { API, Auth } from 'aws-amplify';
import { useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@aws-amplify/ui-react/styles.css';
import './AccountList.css';

type HomeProps = {
  activeLink: VoidFunction;
};

type ParamState = {
  id: string;
};

type getViewAccount = [
  { userId: string, password: string, }
];

type SaggitaDataType = 
  {
    checked: boolean;
    saggitaId: string;
    name: string;
    modify: boolean;
  };

type FailedType =
{
  code: string;
  acc: string;
};

const initialSampleData = {checked: false, saggitaId: "", name: "", modify: false};

const initGetViewAccount = { userId: "", password: "" };

const AccountManage: React.FC<HomeProps> = (props) => {
  const [viewAccount, setViewAccount] = useState<getViewAccount>([initGetViewAccount]);
  const [orgViewAccount, setOrgViewAccount] = useState<getViewAccount>([initGetViewAccount]);
  const [accountName, setAccountName] = useState<string>("");
  const [accountId, setAccountId] = useState<string>("");
  const [alertText, setAlertText] = React.useState('');
  const [alertClass, setAlertClass] = React.useState('alert alert-danger d-none');
  const [submitBtnDisable, setDisableSubmitBtn] = useState<boolean>(false);
  const [viewPassErrorText, setViewPassErrorText] = useState<Array<string>>([""]);
  const [viewPassSuccessText, setViewPassSuccessText] = useState<Array<string>>([""]);
  const [viewNameErrorText, setViewNameErrorText] = useState<Array<string>>([""]);
  const [viewNameSuccessText, setViewNameSuccessText] = useState<Array<string>>([""]);
  const [accNameErrorText, setAccNameErrorText] = useState<string>("");

  const inputNomal = "form-control m-0 pt-1 pb-1";
  const inputInvalid = "form-control m-0 pt-1 pb-1 is-invalid";
  const inputValid = "form-control m-0 pt-1 pb-1 is-valid";

  const [accNameInputClass, setAccNameInputClass] = useState<string>(inputNomal);
  const [viewPassInputClass, setViewPassInputClass] = useState<Array<string>>([inputNomal]);
  const [viewNameInputClass, setViewNameInputClass] = useState<Array<string>>([inputNomal]);

  const location = useLocation();
  const navigate = useNavigate();
  const param = location.state as ParamState;

  const [saggitaData, setSaggitaData] = useState<Array<SaggitaDataType>>([initialSampleData]);
  const [orgSaggitaData, setOrgSaggitaData] = useState<Array<SaggitaDataType>>([initialSampleData]);
  const [allSaggitaData, setAllSaggitaData] = useState<Array<SaggitaDataType>>([initialSampleData]);
  const [srcSaggitaData, setSrcSaggitaData] = useState<Array<SaggitaDataType>>([initialSampleData]);
  const [dstSaggitaData, setDstSaggitaData] = useState<Array<SaggitaDataType>>([initialSampleData]);
  const [filterEditText, setFilterEditText] = React.useState('');
  const [filterViewText, setFilterViewText] = React.useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [guidMessage,setGuidMessage] = React.useState('編集ボタン押下でグループ紐づけを編集できます。');

  const DuplicationMessage = "NG そのIDは既に存在します。";

  useEffect(() => {
    getAccountData();
    props.activeLink();
  }, [])

  const getAccountData = async () => {
    try {
      const apiName = 'MainApi';
      const path = '/account/' + param.id;
      const myInit = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
      };

      const data = await API.get(apiName, path, myInit);
      setAccountId(data.accountId);
      setAccountName(data.accountName);
      setViewAccount(data.viewAccount);
      setOrgViewAccount(JSON.parse(JSON.stringify(data.viewAccount)));
      createPassClassText(data.viewAccount.length);
      createNameClassText(data.viewAccount.length);
      await getSaggitaData(JSON.parse(JSON.stringify(data.saggitaList)));
      setViewAccount(data.viewAccount);
      setOrgViewAccount(JSON.parse(JSON.stringify(data.viewAccount)));
      createPassClassText(data.viewAccount.length);
      createNameClassText(data.viewAccount.length);
      setAccountName(data.accountName);
      setAccountId(data.accountId);

    } catch (err) {
      console.log(err);
      setAlertMessage('ACC0201 データの取得に失敗しました。');
    }
  }

  const getSaggitaData = async (saggita: string[]) => {
    try {
      const apiName = 'MainApi';
      const path = '/saggita/all';
      const myInit = {
        headers: { 
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
      };
      const data = await API.get(apiName, path, myInit);
      const tdata = data.map((x: any) => {
        return {
          checked: saggita.includes(x.saggitaId),
          saggitaId: x.saggitaId,
          name: x.name,
          modify: false
        };
      }) as SaggitaDataType[];
      const sortedData = tdata.sort((a: any, b: any)=> a.saggitaId < b.saggitaId ? -1 : 1);
      setAllSaggitaData(sortedData);

      let connectSaggitaList: SaggitaDataType[] = sortedData.filter((x: SaggitaDataType) => x.checked === true);
      setSaggitaData(connectSaggitaList);
      setOrgSaggitaData(connectSaggitaList);
      setSrcSaggitaData(JSON.parse(JSON.stringify(connectSaggitaList)));
      setDstSaggitaData(JSON.parse(JSON.stringify(connectSaggitaList)));
    }
    catch (err) {
      setAlertMessage('ACC0205 データの取得に失敗しました。');
      setAllSaggitaData([initialSampleData]);
      setSaggitaData([initialSampleData]);
      setOrgSaggitaData([initialSampleData]);
      setSrcSaggitaData([initialSampleData]);
      setDstSaggitaData([initialSampleData]);
    }
  }

  const createPassClassText = (length: number) => {
    let plusErrorText = viewPassErrorText.concat();
    let plusErrorClass = viewPassInputClass.concat();
    let plusSuccessText = viewPassSuccessText.concat();
    for (let i: number = 0; i < length; i++) {
      plusErrorText.push("");
      plusErrorClass.push(inputNomal);
      plusSuccessText.push("");
    }
    setViewPassInputClass(plusErrorClass);
    setViewPassErrorText(plusErrorText);
    setViewPassSuccessText(plusSuccessText);
  }

  const createNameClassText = (length: number) => {
    let plusErrorText = viewNameErrorText.concat();
    let plusErrorClass = viewNameInputClass.concat();
    let plusSuccessText = viewNameSuccessText.concat();
    for (let i: number = 0; i < length; i++) {
      plusErrorText.push("");
      plusErrorClass.push(inputNomal);
      plusSuccessText.push("");
    }
    setViewNameErrorText(plusErrorText);
    setViewNameInputClass(plusErrorClass);
    setViewNameSuccessText(plusSuccessText);

  }

  const changeViewPassFeedBackText = (index: number, validation: string = inputNomal, message: string = "") => {
    let changeErrorText = viewPassErrorText.concat();
    let changeValidationClass = viewPassInputClass.concat();
    let changeSuccessText = viewPassSuccessText.concat();
    changeErrorText[index] = message;
    changeSuccessText[index] = message;
    changeValidationClass[index] = validation;
    setViewPassErrorText(changeErrorText);
    setViewPassSuccessText(changeSuccessText);
    setViewPassInputClass(changeValidationClass);
    if (!changeValidationClass.includes(inputInvalid) && !viewNameInputClass.includes(inputInvalid) && accNameInputClass !== inputInvalid) {
      setDisableSubmitBtn(false);
    }
  }

  const changeViewNameFeedBackText = (index: number, validation: string = inputNomal, message: string = "") => {
    let changeErrorText = viewNameErrorText.concat();
    let changeValidationClass = viewNameInputClass.concat();
    let changeSuccessText = viewNameSuccessText.concat();
    changeErrorText[index] = message;
    changeSuccessText[index] = message;
    changeValidationClass[index] = validation;
    setViewNameErrorText(changeErrorText);
    setViewNameSuccessText(changeSuccessText);
    setViewNameInputClass(changeValidationClass);
    if (!changeValidationClass.includes(inputInvalid) && !viewPassInputClass.includes(inputInvalid) && accNameInputClass !== inputInvalid) {
      setDisableSubmitBtn(false);
    }
  }

  const setInputClassAllNomal = () => {
    let changeValidationNameClass = viewNameInputClass.concat();
    let changeValidationPAssClass = viewPassInputClass.concat();
    for (let i = 0; i < changeValidationNameClass.length; i++) {
      changeValidationNameClass[i] = inputNomal;
      changeValidationPAssClass[i] = inputNomal;
    }
    setViewNameInputClass(changeValidationNameClass);
    setViewPassInputClass(changeValidationPAssClass);
  }


  const setAlertMessage = (message: string) => {
    setAlertText(message);
    setAlertClass('alert alert-danger');
  }

  const setSuccessMessage = (message: string) => {
    setAlertText(message);
    setAlertClass('alert alert-success');
  }


  const handleChangeViewAcc = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let checkContent = e.target.value;
    let newViewAccount = viewAccount.concat();
    let orgUserIdList = [];
    let userIdList = [];

    const regexStralphabet = /^[0-9a-zA-Z]*$/;
    const regexStrSmall = /[a-z]{1,}/;
    const regexStrLearge = /[A-Z]{1,}/;
    const regexStrNumber = /[0-9]{1,}/;
    const regexSymbol = /[\^\$ \*\\\.\[\]{}\(\)\?"!@#%&/\,><':;|_~`=\+-]{1,}/;
    const regexSpace = /^[\S]+.*[\S]+$/;

    for (var data of orgViewAccount) {
      orgUserIdList.push(data.userId);
    }
    for (var accountData of newViewAccount) {
      userIdList.push(accountData.userId);
    }
    if (e.target.name === 'inputName') {
      changeViewNameFeedBackText(index);
      if (checkContent.length > 8) {
        changeViewNameFeedBackText(index, inputInvalid, "NG IDは8文字以内です");
        setDisableSubmitBtn(true);
      }
      else {
        if (checkContent.length !== 0) {
          if (regexStralphabet.test(checkContent)) {
            if (!orgUserIdList.includes(checkContent)) {
              // オリジナルリストにない
              if (orgViewAccount.length > index) {
                if (!userIdList.includes(checkContent)) {
                  // 現在の設定リストにない
                  changeViewNameFeedBackText(index, inputValid, "OK 変更前: " + orgViewAccount[index].userId);
                } else {
                  // 現在の設定リストにある
                  changeViewNameFeedBackText(index, inputInvalid, DuplicationMessage);
                  setDisableSubmitBtn(true);
                }
              }
              else {
                if (!userIdList.includes(checkContent)) {
                  // 現在の設定リストにない
                  changeViewNameFeedBackText(index, inputValid, "OK");
                } else {
                  // 現在の設定リストにある
                  changeViewNameFeedBackText(index, inputInvalid, DuplicationMessage);
                  setDisableSubmitBtn(true);
                }
              }
              if (!newViewAccount[index].password || newViewAccount[index].password.length === 0) {
                changeViewPassFeedBackText(index, inputInvalid, "NG パスワードは必須です");
                setDisableSubmitBtn(true);
              }
            } else {
              // オリジナルリストにある
              if (userIdList.includes(checkContent)) {
                // 変更予定のIDで存在している
                changeViewNameFeedBackText(index, inputInvalid, DuplicationMessage);
                setDisableSubmitBtn(true);   
              } else {
                // オリジナルにあったが、今は使われていない
                  if (orgViewAccount.length > index) {
                    // 既存行
                    if (orgViewAccount[index].userId !== checkContent) {
                      changeViewNameFeedBackText(index, inputValid, "OK 変更前: " + orgViewAccount[index].userId);
                    } else {
                      //変更していない
                      if (!newViewAccount[index].password || newViewAccount[index].password.length === 0) {
                      changeViewPassFeedBackText(index);
                      }
                    }
                  }else {
                    // 新規行
                      changeViewNameFeedBackText(index, inputValid, "OK");
                  }
              }
            }
          }
          else {
            changeViewNameFeedBackText(index, inputInvalid, "NG IDは半角英数字のみです");
            setDisableSubmitBtn(true);
          }
        }
        else {
          changeViewPassFeedBackText(index);
          if (orgViewAccount.length > index) {
            changeViewNameFeedBackText(index, inputValid, "OK 削除対象: " + orgViewAccount[index].userId);
          }
          else {
            if (!newViewAccount[index].password || newViewAccount[index].password.length === 0) {
              changeViewNameFeedBackText(index);
            }
            else {
              changeViewNameFeedBackText(index, inputInvalid, "NG IDは必須です");
              setDisableSubmitBtn(true);
            }
          }
        }
      }
      newViewAccount[index].userId = checkContent;
      setViewAccount(newViewAccount as getViewAccount);
    }
    else if (e.target.name === 'inputPass') {
      changeViewPassFeedBackText(index);

      if (newViewAccount[index].userId.length === 0) {
        changeViewNameFeedBackText(index, inputInvalid, "NG IDは必須です");
        setDisableSubmitBtn(true);
      }

      if (checkContent.length >= 8 && checkContent.length <= 256) {
        if (!regexSpace.test(checkContent)) {
          changeViewPassFeedBackText(index, inputInvalid, "NG 先頭もしくは末尾に空白文字は入力できません");
          setDisableSubmitBtn(true);
        }
        else if (regexStrLearge.test(checkContent) && regexStrSmall.test(checkContent)
          && regexStrNumber.test(checkContent) && regexSymbol.test(checkContent)) {
            changeViewPassFeedBackText(index, inputValid, "OK");
        }
        else {
          changeViewPassFeedBackText(index, inputInvalid, "NG 英数字記号をそれぞれ含める必要があります");
          setDisableSubmitBtn(true);
        }
      }
      else {
        changeViewPassFeedBackText(index);
        if (checkContent.length !== 0) {
          changeViewPassFeedBackText(index, inputInvalid, "NG パスワードは8文字以上256文字以内です");
          setDisableSubmitBtn(true);
        }
        else {
          if (newViewAccount[index].userId.length === 0) {
            changeViewNameFeedBackText(index);
            setDisableSubmitBtn(false);
          } else if (!orgUserIdList.includes(newViewAccount[index].userId)) {
            changeViewPassFeedBackText(index, inputInvalid, "NG パスワードは必須です");
            setDisableSubmitBtn(true);
          }
        }
      }
      newViewAccount[index].password = checkContent;
      setViewAccount(newViewAccount as getViewAccount);
    }
  }

  const handleBlurViewAcc = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let newViewAccount = viewAccount.concat();

    for (let i: number = 0; i < viewAccount.length; i++) {
      if (i === index) {
        // 同じ行は再評価しない
        continue;
      }
      let elem = document.getElementById((orgViewAccount[i] ? orgViewAccount[i].userId : i) + 'name') as HTMLInputElement;
      // 重複メッセージのみ再評価する
      if (viewNameErrorText[i] === DuplicationMessage) {
        let userIdList = [];
        for (var accountData of newViewAccount) {
          if (accountData.userId === elem.value) {
            userIdList.push(accountData.userId);
          }          
        }
        //重複を確認
        if (userIdList.length === 1) {
          if (orgViewAccount.length > i) {
            changeViewNameFeedBackText(i, inputValid, "OK 変更前: " + orgViewAccount[i].userId);
          } else {
            changeViewNameFeedBackText(i, inputValid, "OK");
          }
        }
      }
    }
  }

  const handleChangeAccName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccountName(e.target.value);
    setAccNameErrorText("");
    let checkContent = e.target.value;
    if (checkContent === "") {
      setAccNameInputClass(inputInvalid);
      setAccNameErrorText("NG 表示名は必須です");
      setDisableSubmitBtn(true);
    }
    else if (checkContent.length > 29) {
      setAccNameInputClass(inputInvalid);
      setAccNameErrorText("NG 表示名は29文字以内です");
      setDisableSubmitBtn(true);
    }
    else {
      setAccNameInputClass(inputValid);
      if (!viewPassInputClass.includes(inputInvalid) && !viewNameInputClass.includes(inputInvalid)) {
        setDisableSubmitBtn(false);
      }
    }
  }

  const handleSubmit = async () => {
    let confirmRet = window.confirm("更新処理を行います。\nよろしいですか？");
    if (!confirmRet) {
      return;
    }

    if (isEditMode) {
      let modeConfiremRet = window.confirm("通信ユニットが編集中です。\n更新処理を続行しますか？");
      if (!modeConfiremRet) {
        return;
      }
    }

    setAlertClass('alert alert-danger d-none');
    let delComfirmMessage = "";
    orgViewAccount.forEach((data, index) => {
      if (viewAccount[index].userId === "") {
        delComfirmMessage += "・" + data.userId + "\n";
      }
    });

    let plusPassViewAccout = viewAccount.concat();
    plusPassViewAccout.forEach((data, index) => {
      if (!data.password) {
        data.password = "";
      }
    });
    setViewAccount(plusPassViewAccout as getViewAccount);


    let resultDel = true;

    if (delComfirmMessage !== "") {
      resultDel = window.confirm("以下のアカウントを削除しますか？\n" + delComfirmMessage);
    }
    var saggitaList: Array<string> = [];
    dstSaggitaData.forEach((data) => {
      if (data.checked) {
        saggitaList.push(data.saggitaId);
      }
    });

    if (resultDel) {
      const sendData = {
        accountManageData: viewAccount,
        accountName: accountName,
        accountId: accountId,
        saggitaList: saggitaList
      };
      try {
        setViewAccount([initGetViewAccount]);
        const apiName = 'MainApi';
        const path = '/account/' + param.id;
        const myInit = {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
          },
          body: sendData
        };
        const data = await API.put(apiName, path, myInit);
        const failed =  JSON.parse(JSON.stringify(data.failed)) as FailedType[];
        if (failed.length) {
          setAccountName(data.accountName);
          const accList = failed.map((mitem: any) => {return mitem.acc;})as string[];
          const codeList = failed.map((mitem: any) => {return mitem.code;})as string[];
          viewAccount.forEach((account, index) => {
            if (!accList.includes(account.userId)) {
              changeViewNameFeedBackText(index);
              changeViewPassFeedBackText(index);
            }
          });
          let tempViewAccount = viewAccount.concat();
          setViewAccount(tempViewAccount as getViewAccount);
          if (codeList.includes("400")) {
            setAlertMessage('ACC0202 設定した閲覧アカウントIDは既に存在します。更新失敗ID: ' + accList);            
          } else {
            setAlertMessage('ACC0203 データの更新に失敗しました。時間をおいてから再度更新ボタンを押してください。　更新失敗ID: ' + accList);
          }
        } else {
          setOrgViewAccount(JSON.parse(JSON.stringify(data.viewAccount)));
          setAccNameInputClass(inputNomal);
          setViewAccount(data.viewAccount);
          setAccountName(data.accountName);     
          setSuccessMessage("更新が完了しました");
          await getAccountData();
          setInputClassAllNomal();
        }
      } catch (err) {
        setViewAccount(sendData.accountManageData as getViewAccount);
        setAlertMessage('ACC0204 データの更新に失敗しました。');
      }
      setIsEditMode(false);
      setGuidMessage('編集ボタン押下でグループ紐づけを編集できます。');
    }
  }

  const handleNewInput = () => {
    let plusInput = viewAccount.concat();
    plusInput.push({ userId: "", password: "" });
    setViewAccount(plusInput as getViewAccount);
    createNameClassText(viewAccount.length);
    createPassClassText(viewAccount.length);
  }

  const handleChangeFilterText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterEditText(e.target.value);
    setFilterViewText(e.target.value)
    setSaggitaData(
      orgSaggitaData.filter((item: SaggitaDataType) => {
        return item.name.includes(e.target.value) || item.saggitaId.includes(e.target.value);
      }
    ) as SaggitaDataType[]);
  }
  
  const handleClickBtn = (id: string) => {
    let confirmRet = window.confirm("通信ユニットの編集画面に遷移します。\nよろしいですか？");
    if (confirmRet) {
      navigate('/saggita/mng', {state: { 'id': id }});
    }
  }

  const handleClickEditBtn = () => {
    setFilterViewText('');
    setSaggitaData(allSaggitaData);
    setOrgSaggitaData(allSaggitaData);
    setIsEditMode(!isEditMode);
    setGuidMessage("「決定」ボタンを押下時は、編集内容が決定した状態です。反映するには「更新」ボタン押下が必要です。");
  }

  const handleClickDecisionBtn = () => {
    let saggitaUnitList = "";
    const checkedList = orgSaggitaData.filter((item: SaggitaDataType) => {
        return item.checked;
      }
    ) as SaggitaDataType[];

    for (var data of checkedList) {
      saggitaUnitList += '\n' + data.saggitaId + " " + data.name;
    }

    if (saggitaUnitList === "") {
      saggitaUnitList = "\n通信ユニットなし"
    }

    const btnref = window.confirm("紐づけ通信ユニットは以下となります。\nよろしいですか？\n" + saggitaUnitList);
    if (!btnref) {
      return;
    }

    setFilterEditText('');
    setSaggitaData(checkedList);
    setOrgSaggitaData(checkedList);
    setDstSaggitaData(checkedList)
    setAllSaggitaData(orgSaggitaData);
    setIsEditMode(!isEditMode);
    if ((orgSaggitaData.filter((x: SaggitaDataType) => {return x.modify;}) as SaggitaDataType[]).length === 0 ) {
      setGuidMessage("「編集」ボタン押下でグループ紐づけを編集できます。")
    }else {
      setGuidMessage("通信ユニットの変更は、まだ反映されていません。反映するには「更新」ボタンを押下してください。")
    }
  }

  const handleChangeCheck = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    saggitaData[index].checked = e.target.checked;
    const checkedIndex = orgSaggitaData.findIndex((x) => x.saggitaId === saggitaData[index].saggitaId);
    orgSaggitaData[checkedIndex].checked = e.target.checked;

    const srcIndex  = srcSaggitaData.findIndex((x) => x.saggitaId === saggitaData[index].saggitaId);
    if (srcIndex === -1) {
      saggitaData[index].modify =true;
      orgSaggitaData[checkedIndex].modify = true;
    } else {
      if (srcSaggitaData[srcIndex].checked === saggitaData[index].checked) {
        saggitaData[index].modify =false;
        orgSaggitaData[checkedIndex].modify = false;
      } else {
        saggitaData[index].modify =true;
        orgSaggitaData[checkedIndex].modify = true;
      }
    }
  }

  const handleViewClickBtn = (id: string) => {
    if (process.env.REACT_APP_VIEW_WEB_PAGE_URL) {
      window.open(process.env.REACT_APP_VIEW_WEB_PAGE_URL + '/' + id, '_blank');
    }
  }

  const handleClickAllCheck = () => {
    for (let i: number = 0; i < saggitaData.length; i++) {
      saggitaData[i].checked = true;
      let elem = document.getElementById('check'+saggitaData[i].saggitaId) as HTMLInputElement;
      elem.checked = true;

      const srcData = srcSaggitaData.find((x) => x.saggitaId === saggitaData[i].saggitaId);
      if (srcData){
        if (saggitaData[i].checked === srcData.checked) {
          saggitaData[i].modify = false;
        } else {
          saggitaData[i].modify = true;
        }
      } else {
        saggitaData[i].modify = true;
      }

      const index =  orgSaggitaData.findIndex(x => x.saggitaId === saggitaData[i].saggitaId);
      orgSaggitaData[index].checked = saggitaData[i].checked;
      orgSaggitaData[index].modify = saggitaData[i].modify;
    }

    setSaggitaData(saggitaData);
    setOrgSaggitaData(orgSaggitaData);
  }

  const handleClickAllFree = () => {
    for (let i: number = 0; i < saggitaData.length; i++) {
      saggitaData[i].checked = false;
      let elem = document.getElementById('check'+saggitaData[i].saggitaId) as HTMLInputElement;
      elem.checked = false;
      
      const srcData = srcSaggitaData.find((x) => x.saggitaId === saggitaData[i].saggitaId);
      if (srcData){
        if (saggitaData[i].checked === srcData.checked) {
          saggitaData[i].modify = false;
        } else {
          saggitaData[i].modify = true;
        }
      } else {
        saggitaData[i].modify = true;
      }

      const index =  orgSaggitaData.findIndex(x => x.saggitaId === saggitaData[i].saggitaId);
      orgSaggitaData[index].checked = saggitaData[i].checked;
      orgSaggitaData[index].modify = saggitaData[i].modify;
    }

    setSaggitaData(saggitaData);
    setOrgSaggitaData(orgSaggitaData);
  }

  return (
    <div className="p-3">
      <h4>グループの編集</h4>
      <div className={alertClass} role="alert">{alertText}</div>
      <p className='m-0 p-0'>{accountId}</p>
      <form className="needs-validation" noValidate>
        <table className="table table-borderless text-nowrap m-0 p-0" style={{ 'width': '700px' }}>
          <tbody>
            <tr>
              <td className='pt-3 m-0' style={{ 'width': '60px' }}>グループ名称</td>
              <td>
                <div className='form-group '>
                  <input type="text" className={accNameInputClass} style={{ 'width': '600px' }} id="groupName" value={accountName} placeholder='グループ名称を入力' autoComplete='off' onChange={(e) => handleChangeAccName(e)} required></input>
                  <div className="valid-feedback">
                    OK
                  </div>
                  <div className="invalid-feedback" id='accNameErr'>
                    {accNameErrorText}
                  </div>
                </div>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <table className='form-group m-0 p-0' style={{minWidth: '750px', maxWidth: '1000px'}}>
          <tbody>
            <tr>
              <td style={{ 'width': '100px' }}>
                <span className='m-0 p-0'>通信ユニット</span>
              </td>
              <td style={{ 'width': '100px' }}>
                {!isEditMode && <input type="button" className='btn btn-primary ml-3' id="editBtn" value={'編集'} onClick={() => handleClickEditBtn()}></input>}
                {isEditMode && <input type="button" className='btn btn-primary ml-3' id="decisionBtn" value={'決定'} onClick={() => handleClickDecisionBtn()}></input>}
              </td>
              <td>
                <span className='text-danger' >{guidMessage}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table className="table table-borderless text-nowrap mt-0 ml-0 mr-0 mb-3 p-0" style={{ 'width': '700px' }}>
          <tbody>
            <tr>
              <td className='form-group mt-3' style={{ 'width': '700px' }}>
                {!isEditMode && <input type="text" id="filterEdit_text" value={filterEditText} placeholder='フィルター' onChange={(e) => handleChangeFilterText(e)}></input>}
                {isEditMode && <input type="text" id="filterView_text" value={filterViewText} placeholder='フィルター' onChange={(e) => handleChangeFilterText(e)}></input>}
              </td>
            </tr>
            {isEditMode && <tr>
              <td className='form-group m-0 p-0 '>
                <input type="button" className='btn btn-primary mr-3' id="allBtn" value={'全選択'} onClick={() => handleClickAllCheck()} ></input>
                <input type="button" className='btn btn-primary' id="delBtn"  value={'全解除'} onClick={() => handleClickAllFree()} ></input>
              </td>
            </tr>}
            {
              (() => {
                if (saggitaData.length) {
                  if (saggitaData[0].saggitaId === '') {
                    return;
                  }
                  else {
                    let list
                    if (isEditMode) {
                      list = saggitaData.map((data, index) => (
                        <tr key={'tr' + data.saggitaId}>
                          <td className='pt-0 pb-0 m-0' key={'td' + data.saggitaId}>
                            <input className="align-middle" type="checkbox" id={'check' + data.saggitaId} key={'check' + data.saggitaId} defaultChecked={data.checked} onChange={(e) => handleChangeCheck(e, index)} />
                            <label className="btn mb-1" htmlFor={'check' + data.saggitaId} key={'name' + data.saggitaId}>{data.saggitaId + ' ' + data.name}</label>
                          </td>
                        </tr>
                      ));
                    }
                    else {
                        list = saggitaData.map((data) => (
                        <tr key={'tr' + data.saggitaId}>
                          <td className='pt-0 pb-0 m-0' key={'td' + data.saggitaId }>
                            {!data.modify && <span className="btn" key={'name' + data.saggitaId}>{data.saggitaId + ' ' + data.name}</span>}
                            {data.modify && <span className="btn text-danger" key={'name' + data.saggitaId}>{data.saggitaId + ' ' + data.name}</span>}
                            <input type="button" className="btn btn-link" key={'editbtn' + data.saggitaId} value="編集"  onClick={() => handleClickBtn(data.saggitaId)} />
                            <input type="button" className="btn btn-link" key={'viewbtn' + data.saggitaId} value="閲覧"  onClick={() => handleViewClickBtn(data.saggitaId)} />
                          </td>
                        </tr>
                      ));
                    } 
                    return (list);
                  }
                }
                else {
                  return (
                    <tr>
                      <td>データがありません。</td>
                    </tr>
                  );
              }
              })()
            }
          </tbody>
        </table>
        <p className='m-0 p-0'>閲覧アカウント</p>
        <table className="table table-borderless text-nowrap m-0 p-0" style={{ 'width': '700px' }}>
          <tbody>
            {
              viewAccount.map((data, index) => (
                <tr key={'key' + index}>
                  <td className='pt-3 m-0' style={{ 'width': '30px' }}> 閲覧アカウントID</td>
                  <td className="m-0" style={{ 'width': '240px' }}>
                    <div className="form-group m-0 p-0">
                      <input type="text" className={viewNameInputClass[index]} key={'name' + (orgViewAccount[index] ? orgViewAccount[index].userId : index)} id={(orgViewAccount[index] ? orgViewAccount[index].userId : index) + 'name'} name="inputName" value={data.userId} placeholder='IDを入力' autoComplete='new-off' onChange={(e) => handleChangeViewAcc(e, index)} onBlur={(e) => handleBlurViewAcc(e, index)} required></input>
                      <div className="valid-feedback">
                        {viewNameSuccessText[index]}
                      </div>
                      <div className="invalid-feedback">
                        {viewNameErrorText[index]}
                      </div>
                    </div>
                  </td>
                  <td className='pt-3 m-0' style={{ 'width': '50px' }}>パスワード</td>
                  <td className="m-0" style={{ 'width': '240px' }}>
                    <div className="form-group m-0 p-0">
                      <input type="password" className={viewPassInputClass[index]} key={'pw' + (orgViewAccount[index] ? orgViewAccount[index].userId : index)} id={(orgViewAccount[index] ? orgViewAccount[index].userId : index) + 'pass'} name="inputPass" value={data.password} placeholder='パスワードを入力' autoComplete='new-off' onChange={(e) => handleChangeViewAcc(e, index)} required></input>
                      <div className="valid-feedback">
                        {viewPassSuccessText[index]}
                      </div>
                      <div className="invalid-feedback" id={data.userId + "passInvalid"}>
                        {viewPassErrorText[index]}
                      </div>
                    </div>
                  </td>
                  <td className=''></td>
                </tr>
              ))
            }
          </tbody>
        </table>
        <div className='form-group m-0 p-0 mb-1'>
          <input type="button" className='btn btn-info' id="addInputBtn" value={'＋'} onClick={() => handleNewInput()}></input>
        </div>
        <div className='form-group m-0 p-0 '>
          <input type="button" className='btn btn-primary' id="updateBtn" value={'更新'} onClick={() => handleSubmit()} disabled={submitBtnDisable}></input>
        </div>
      </form>
    </div>
  );
}

export default AccountManage;
